import Service from "../../Services";

const UserRole = {
  namespaced: true,
  state: {
    form: {
      id : '',
      role_name : '',
      status : true,
      permission :[],
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id : '',
        role_name : '',
        status : true,
        permission :[],
      };
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getUserRole({ commit }, {page,search,sort_date}) {
      return Service.UserRoleAPI.getUserRole(page,search,sort_date);
    },
    // eslint-disable-next-line no-unused-vars
    showUserRole({ commit }, id) {
      return Service.UserRoleAPI.showUserRole(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveUserRole({ commit }, { id, data }) {
      if (id) {
        return Service.UserRoleAPI.updateUserRole(id, data);
      } else {
        return Service.UserRoleAPI.createUserRole(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteUserRole({ commit }, id) {
      return Service.UserRoleAPI.deleteUserRole(id);
    },
    setFormUserRole({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    getUserRoleAll({commit}){
      return Service.UserRoleAPI.getAllUserRole();
    },
    getAllFeature({commit}){
      return Service.UserRoleAPI.getAllFeature();
    },
  }
};
export default UserRole;
